export const MUTATE = 'MUTATE';
export const SET_MUTATION_RESPONSE = 'SET_MUTATION_RESPONSE';
export const RESET_MUTATION_RESPONSE = 'RESET_MUTATION_RESPONSE';
